import React from 'react';
import {
  makeStyles,
  Container,
  Box,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  Card,
  CardHeader,
  Typography
} from '@material-ui/core';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Page from 'src/components/Page';
import TablePagination from 'src/components/TablePagination';
import useQueryString from 'src/hooks/useQueryString';
import Admin from 'src/api/admin';

const useStyles = makeStyles(() => ({
  root: {},
  row: {
    cursor: 'pointer'
  }
}));

const REASON_LABELS = {
  needs_review: 'Partial match',
  duplicate: 'Duplicate ID',
  provider_error: 'Provider error',
  manual: 'Document upload'
};

const CHECK_LABELS = {
  nin: 'NIN',
  drivers_license: "Driver's licence",
  passport: 'Passport'
};

export default function VerificationReviews() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [query, setQueryString] = useQueryString();

  const { data = {} } = useQuery(
    ['verificationReviews', query],
    () => Admin.getVerificationReviews(query),
    {
      keepPreviousData: true,
      onError: err => {
        // Interceptor already toasted network errors (ISSUE-0201).
        if (err.response) {
          const { data: errData } = err.response;
          toast.error(
            errData?.errors?.[0] || errData?.message || 'Something went wrong'
          );
        }
      }
    }
  );

  const { data: reviews = [] } = data;
  return (
    <Page className={classes.root} title="Verification reviews">
      <Container maxWidth={false}>
        <Box mb={4}>
          <Card>
            <CardHeader title="Verification reviews" />
          </Card>
        </Box>
        <Card>
          <PerfectScrollbar>
            <Box minWidth={1050}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell>Reason</TableCell>
                    <TableCell>Check</TableCell>
                    <TableCell>Detail</TableCell>
                    <TableCell>Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {reviews.map(review => (
                    <TableRow
                      hover
                      key={review.id}
                      className={classes.row}
                      onClick={() =>
                        navigate(`/app/customers/${review.userId}`)
                      }
                    >
                      <TableCell>
                        <Typography color="textPrimary" variant="body1">
                          {review.user
                            ? `${review.user.firstName} ${review.user.lastName}`
                            : '-'}
                        </Typography>
                        <Typography color="textSecondary" variant="body2">
                          {review.user?.email}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {REASON_LABELS[review.reason] || review.reason}
                      </TableCell>
                      <TableCell>
                        {CHECK_LABELS[review.check] || review.check || '-'}
                      </TableCell>
                      <TableCell>{review.detail || '-'}</TableCell>
                      <TableCell>
                        {new Date(review.updatedAt).toLocaleString()}
                      </TableCell>
                    </TableRow>
                  ))}
                  {!reviews.length && (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        No verifications waiting for review.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </PerfectScrollbar>
          {data.pagination && (
            <TablePagination
              count={data.pagination.totalCount}
              page={data.pagination.currentPage}
              rowsPerPage={data.pagination.rows}
              onChangeRowsPerPage={rows => setQueryString({ rows })}
              onChangePage={pageNo => setQueryString({ pageNo })}
            />
          )}
        </Card>
      </Container>
    </Page>
  );
}
